import { Injectable } from "@angular/core";

@Injectable()
export class ParamsConstants {
  static readonly UUID = "uuid";
  static readonly TYPE = "type";
}